<script setup lang="ts">
import { useSlots } from 'vue';
import PartTitleHead from '@parts/part-title-head.vue';

const slots = useSlots();
const props = defineProps({
	fields: {
		type: Object,
		default: () => ({})
	}
});
</script>
<template>
	<section class="section-account">
		<div class="section-account__head">
			<div class="wrapper">
				<part-title-head
					v-if="fields.title || fields.subtitle"
					:icon="fields?.icon"
					:title="fields.title"
					:subtitle="fields.subtitle"
					class="section-help__content"
				></part-title-head>
			</div>
		</div>

		<div
			v-if="slots.append"
			class="section-account__append"
		>
			<slot name="append" />
		</div>

		<div class="section-account__body">
			<div class="wrapper">
				<slot />
			</div>
		</div>
	</section>
</template>

<style lang="scss">
.section-account {
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;

	&__head {
		flex: 0 0 auto;
	}
	&__body {
		flex: 1 1 auto;
		min-height: 0;
		display: flex;
		flex-direction: column;
	}
}
</style>
